'use strict';
require('../../modules/es.object.entries');
var path = require('../../internals/path');

module.exports = path.Object.entries;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/es/object/entries.js
// module id = 340
// module chunks = 0